const DAILY = 'Daily';
const WEEKLY = 'Weekly';
const MONTHLY = 'Monthly';
const DISABLED = 'None';

const recurrenceTypes = {
  DAILY,
  WEEKLY,
  MONTHLY,
  DISABLED,
};

export default recurrenceTypes;
